<template>
  <div v-if="broker != null && person != null">

    <div class="text-lg">Send a birthday email</div>
    
    <div class="mt-6 w-1/2">
      <label class="text-sm">
        Your client <span class="font-semibold">{{ person.first_name }} {{ person.last_name }}</span>'s birthday is coming up in 3 days
        - {{ person.born_at }}.

        Please review the message below and send.
      </label>

      <div class="mt-4">
        <textarea
          class="w-full border border-gray-600 p-3 outline-none text-sm"
          style="height:250px;"
          v-model="message" />
      </div>

      <div class="mt-12">
        <SubmitButton2 :onClick="submit" :loading="loading" label="Send" />
      </div>
    </div>
    <br/><br/><br/>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      SubmitButton2
    },

    data () {
      return {
        loading: false,
        broker : null,
        person : null,
        message: null
      }
    },

    created() {
      this.broker = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)

      this.apiGet({
        personId : this.$route.params.personId
      }, 'applicant/person', (person) => {
        this.person = person

        this.message = "Hi " + this.person.first_name + ", how are you? Hope you are doing well.\r\n\r\n" + 
                       "This is " + this.$store.state.user.first_name + " " + this.$store.state.user.last_name + ".\r\n\r\n" + 
                       "I noticed that your birthday is coming up soon and I just wanted to send you a quick message to wish you a happy birthday.\r\n\r\n" + 
                       "Hope everything is well with you.\r\n" + 
                       "Take care,\r\n\r\n" + 
                       this.$store.state.user.first_name
      })
    },

    methods : {
      submit() {
        this.loading = true
        this.apiPost({
          personId: this.person.id,
          message : this.message,
        }, 'broker/send-client-birthday-email', () => {
          this.loading = false
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'Email sent successfully.'
          })

          this.$router.push({
            name : 'client-list'
          })
        })
      }
    },
  }
</script>